"use strict";

exports.__esModule = true;
exports.showOverlay = exports.show = exports.nextStep = exports.identityAccountId = exports.eventBase = exports.customerSupport = exports.conversionWall = exports.clickConfirm = exports.clickClose = exports.click = exports.changeProduct = void 0;

var _utmParser = require("../../modules/glitr-tracker/helpers/utmParser.js");

const eventBase = {
  type: 'event',
  ...(0, _utmParser.utmParser)(window.location.search)
};
exports.eventBase = eventBase;
const conversionWall = {
  eventtype: 'subscriptionshop',
  eventcategory: 'subscriptionshop'
};
exports.conversionWall = conversionWall;
const show = {
  eventaction: 'show'
};
exports.show = show;
const showOverlay = {
  eventaction: 'show-overlay'
};
exports.showOverlay = showOverlay;
const nextStep = {
  eventaction: 'click-next-step'
};
exports.nextStep = nextStep;
const customerSupport = {
  eventaction: 'click-customerservice'
};
exports.customerSupport = customerSupport;
const changeProduct = {
  eventaction: 'click-edit-product'
};
exports.changeProduct = changeProduct;
const clickClose = {
  eventaction: 'click-close'
};
exports.clickClose = clickClose;
const clickConfirm = {
  eventaction: 'click-confirm'
};
exports.clickConfirm = clickConfirm;
const click = {
  eventaction: 'click'
};
exports.click = click;

const identityAccountId = user => ({
  identityaccountid: user ? user.accountGuid || null : null
});

exports.identityAccountId = identityAccountId;